import React from 'react';
import { HelpCircle } from 'lucide-react';

const ContactCTA = () => {
  return (
    <div className="mt-20 text-center">
      <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-3xl p-12 border border-red-200">
        <div className="max-w-2xl mx-auto">
          <div className="w-16 h-16 bg-[var(--primarycolor)] rounded-2xl flex items-center justify-center mx-auto mb-6">
            <HelpCircle className="w-8 h-8 text-white" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Still have questions?
          </h3>
          <p className="text-gray-600 mb-8 leading-relaxed">
            Our team is here to help you with any additional questions about Dignity Living retirement community.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
            <a
              href="#contact"
              className="bg-[var(--primarycolor)] text-white px-8 py-4 rounded-full font-semibold hover:bg-red-900 transition-colors duration-300 shadow-lg hover:shadow-xl"
            >
              Contact Us
            </a>
            <a
              href="tel:+918590442525"
              className="bg-white text-[var(--primarycolor)] px-8 py-4 rounded-full font-semibold hover:bg-red-50 transition-colors duration-300 border-2 border-red-200"
            >
              +91 8590442525
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCTA;